export enum urlParamsEnum {
  HAS_OWN_DOMAIN = 'hasOwnDomain',
  CUSTOMER_TYPE = 'customerType',
  SITE_ID = 'siteId',
  UPGRADE_SITE_ID = 'SiteId',
  FREE_DOMAIN_VOUCHER = 'freeDomainVoucher',
  SUBSCRIPTION_GROUP_ALT_ID = 'subscriptionGroupAltId',
  V2_ENABLED = 'v2Enabled',
  DEVICE_TYPE = 'deviceType',
  WITH_TEST_DATA = 'withTestData',
  SOURCE = 'source',
  REQUESTOR = 'requestor',
  DOMAIN_NAME = 'domainName',
}
